export enum SizeFile {
    B = "B",
    KB = "KB",
    MB = "MB",
    GB = "GB",
    TB = "TB"
};